import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_layout/templates/quotes_/$packageId/_list/tasks/$taskId/",
)({
  component: Empty,
})

function Empty(): React.ReactElement {
  return <span />
}
